<template>
  <div>
    <div class="search-wrapper">
      <div class="search">
        <span>项目名称：</span>
        <Input style="width:180px;" placeholder="模糊查询" v-model="searchForm['title']"></Input>
      </div>
      <div class="search">
        <span>单位名称：</span>
        <Input style="width:180px;" placeholder="模糊查询" v-model="searchForm['companyName']"></Input>
      </div>
      <div class="search">
        <span>金额：</span>
        <Input style="width:200px;" v-model="searchForm['amount']"></Input>
      </div>
      <div class="search">
        <span>状态：</span>
        <Select style="width:200px;" v-model="searchForm.Status">
          <Option v-for="item in statusList" :value="item.value" :key="item.value">{{ item.label }}</Option>
        </Select>
      </div>
      <Button type="primary" icon="ios-search" style="margin: 0 10px;" @click="searchEnroll">搜索</Button>
      <Button icon="ios-loop-strong" type="primary" style="margin-right:5px;" @click="resetSearch">重置搜索</Button>
      <Button icon="ios-list-outline" type="success" @click="showCharge = true">服务费收入一览</Button>
    </div>
    <Spin :fix="true" v-if="pageSpin"></Spin>
    <!-- 数据列表 -->
    <Table :columns="columns" :data="tableData" style="min-width:1300px;"></Table>
    <!-- 服务费收入一览弹窗 -->
    <Modal v-model="showCharge" title="服务费收入一览" width="98%" height="95%" class="declare-report">
      <iframe :src="reportUrl + user.selectDistrict" style="width:100%;height:700px;border:0"></iframe>
      <div slot="footer"></div>
    </Modal>
    <!-- 收退信息/发票信息 弹窗 -->
    <refund-info 
      ref="refund" 
      :title="modalTitle"
      :showRefund="showRefund" 
      @searchEnroll="searchEnroll"
      @visibleChange="(val)=>{showRefund=val}">
    </refund-info>
    <Page ref="page" @on-change="pageChange" :total="pageTotal" :current="currentPage" show-elevator show-total style="margin:5px;"></Page>
  </div>
</template>

<script>
import ajax from '@/lib/ajax'
import axios from 'axios'
import util from '@/lib/util'
import requestUrls from '@/lib/requestUrls'
import { formatDate, firstToUpperCase } from '@/lib/tool'
import refundInfo from './refundInfo'

// 订单状态 0：未确认 1：已确认 2：线上支付未确认
export default {
  components: {
    refundInfo
  },
  computed: {
    user() {
      return this.$store.state.session.user
    }
  },
  data() {
    return {
      // baseUrl: 'http://www.choicelink.cn:8888',  // 接口url开头
      // baseUrl: 'http://medical.chinapsp.cn:8888',  // 接口url开头
      baseUrl: 'https://api.choicelink.cn/NewFinancial',  // 接口url开头
      reportUrl: 'http://report.choicelink.cn:8082/WebReport/ReportServer?reportlet=newcailian%2Fwx%2F%28%5B65b0%5D%29%5B667a%5D%5B91c7%5D%5B9879%5D%5B76ee%5D%5B6536%5D%5B5165%5D%5B4e00%5D%5B89c8%5D.cpt&%E5%9C%B0%E5%8C%BA=',
      // searchForm: {
      //   Area:"",
      //   page: 1,
      //   rows: 10,
      //   'Title%': "",
      //   "CompanyName%":"",
      //   "Amount%": "",
      //   Status:"",
      // },  //当前搜索框
      searchForm: {
        Area:"",
        page: 1,
        rows: 10,
        'title': "",
        "companyName":"",
        "amount": "",
        Status:"",
      },  //当前搜索框
      statusList: [
        {
          value: '0',
          label: '未确认'
        },
        {
          value: '1',
          label: '已确认'
        },
        {
          value: '2',
          label: '线上支付未确认'
        },
      ],  //订单状态
      tableData: [],
      columns: [
        {
          title: '地区',
          width: 100,
          render: (h,params) => {
            return params.row.Area == 'null' ? h('div', '') : h('div', params.row.Area)   // 地区是否为空
          }
        },
        {
          title: '项目名称',
          key: 'Title'
        },
        {
          title: '单位名称',
          key: 'CompanyName'
        },
        {
          title: '添加时间',
          width: 168,
          align: 'center',
          render: (h, params) => {
            return params.row.CreateTime ? h('div', params.row.CreateTime.replace('T', ' ')) : ''   // 时间格式化
          }
        },
        {
          title: '应收服务费',
          width: 100,
          align: 'center',
          render: (h, params) => {
            return params.row.Amount ? h('div', `${params.row.Amount}元`) : h('div', '无')
          }
        },
        {
          title: '实收服务费',
          width: 100,
          align: 'center',
          render: (h, params) => {
            return params.row.DAmount ? h('div', `${params.row.DAmount}元`) : h('div', '无')
          }
        },
        {
          title: '收款时间',
          width: 168,
          align: 'center',
          render: (h, params) => {
            let payTime = params.row.PayTime ? params.row.PayTime.replace('T', ' ') : '无'
            if (payTime !== '无') payTime = payTime.slice(0, 16)
            return h('div', payTime)    // 时间格式化
          }
        },
        {
          title: '发票',
          width: 70,
          render: (h, params) => {
            let status = '未开'
            let ifOpen = params.row.OrderList.some(item => item.OrderStatus == '3' || item.OrderStatus == '5')
            // if (orderList.length > 0 && (orderList[0]['OrderStatus'] == '3' || orderList[0]['OrderStatus'] == '5')) {
            //   status = '已开'
            // }
            if (ifOpen) status = '已开'
            return h('div', status)
          }
        },
        {
          title: '操作',
          width: 260,
          align: 'center',
          render: (h, params) => {
            return h('div', [
              h('Button', {
                props: {
                  type: 'primary',
                  size: 'small',
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.modalTitle = '收退信息'
                    this.showRefund = true
                    this.$refs.refund.getAllXhfCompany(params.row)
                  }
                }
              }, '收退信息'),
              h('Button', {
                props: {
                  type: 'warning',
                  size: 'small',
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.modalTitle = '发票信息'
                    this.showRefund = true
                    this.$refs.refund.getAllXhfCompany(params.row)
                  }
                }
              }, '发票信息'),
              h('Button', {
                props: {
                  type: 'primary',
                  size: 'small',
                  disabled: params.row.Status === '0'  // 未确认收费
                },
                on: {
                  click: async () => {
                    this.modalTitle = '信息补录'
                    this.showRefund = true
                    this.$refs.refund.getAllXhfCompany(params.row)
                  }
                }
              }, '信息补录'),
            ]);
          }
        }
      ],
      currentPage: 1,
      pageTotal: 0,
      showCharge: false,
      showRefund: false,
      modalTitle: ''
    }
  },
  async created() {
    this.init(1)
  },
  mounted() {
    this.getBankAccount()
  },
  methods: {
    async getBankAccount(area = '', bankName = '') {
      let filter = ''
      let areaFilter = area ? ` and (district=="${area}" or xhfCompanyName=="广东采联采购科技有限公司" or xhfCompanyName=="采联国际招标采购集团有限公司")` : ''
      let bankNameFilter = bankName ? ` and xhfBankName.contains("${bankName}")` : ''
      filter = areaFilter + bankNameFilter
      filter = filter.slice(5)
      let rep = await ajax.get(requestUrls.bankAccount.getAll, {
        params: {
          filter: filter
        }
      })
      if (rep.data.success) {
        this.bankAccountArr = rep.data.result.items
      }
    },
    // 获取数据列表
    async init(page) {
      this.pageSpin = true
      let filter = `title.Contains("${this.searchForm.title}") and companyName.Contains("${this.searchForm.companyName}") and status.Contains("${this.searchForm.Status}")`
      if(this.searchForm.amount) filter += ` and amount == ${this.searchForm.amount}`
      axios.get(this.baseUrl + "/api/services/app/FinancialCharges/GetPagedWithOrder", {
        params: {
          filter: filter,
          skipCount: (page - 1) * 10,
          sorting: 'createTime desc',
          maxResultCount: 10
        }
      }).then(res => {
        // 数据格式化 首字母大写
        res.data.result.items.forEach(item => {
          let obj = {}
          Object.keys(item).forEach(key => {
            if (key === 'orderList' || key === 'payCheckList') {
              this.$set(obj, firstToUpperCase(key), [])
              item[key].forEach(el => {
                let obj2 = {}
                Object.keys(el).forEach(key2 => {
                  this.$set(obj2, firstToUpperCase(key2), el[key2])
                })
                obj[firstToUpperCase(key)].push(obj2)
              })
            } else {
              this.$set(obj, firstToUpperCase(key), item[key])
            }
          })
          this.tableData.push(obj)
        })
        this.pageTotal = res.data.result.totalCount
        this.pageSpin = false
      }).catch(err => {
        this.$Message.error('数据请求失败！')
      });
    },
    // 分页
    pageChange(page) {
      this.tableData = []
      this.currentPage = page
      this.init(page)
    },
    // 搜索按钮
    searchEnroll(e) {
      // e 判断是否组件刷新
      this.currentPage = e == '1' ? this.currentPage : 1
      this.tableData = []
      this.init(this.currentPage)
    },
    // 重置搜索
    resetSearch() {
      this.currentPage = 1
      this.searchForm = {
        Area:"",
        page: 1,
        rows: 10,
        'title': "",
        "companyName":"",
        "amount": "",
        Status:"",
      }
      this.init(1)
    },
  },
}
</script>

<style lang="less">
.search-wrapper {
  margin: 5px;
  .search {
    display: inline-block;
    margin-right: 5px;
    margin-bottom: 5px;
  }
  .input-enroll {
    width: 100px;
    display: inline-block;
  }
}
</style>